import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-mapeamento", {
        attrs: {
          fim: _vm.mapeamento.fimPerComportServidor,
          inicio: _vm.mapeamento.inicioPerComportServidor,
          acesso: "COMUM",
          titulo: "Competências Comportamentais",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.usuarioMapeamento.tipo != "REGULAR"
                  ? _c(
                      VCol,
                      [
                        _c("info-dispensa", {
                          attrs: {
                            mensagem: `Usuário não realiza cadastro de comportamento.`,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.mapeamento.mapeamentoImportado && _vm.loaded
                  ? _c(
                      VCol,
                      [
                        _c("app-alert", {
                          attrs: {
                            type: "info",
                            message: `Mapeamento importado através do mapeamento (${_vm.mapeamento.mapeamentoImportado.nome})`,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                (_vm.prazoAtual || _vm.prazoEsgotado) &&
                _vm.usuarioMapeamento.tipo == "REGULAR"
                  ? _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(
                          VCol,
                          [
                            _c(
                              VTabs,
                              {
                                attrs: { centered: "", "icons-and-text": "" },
                                model: {
                                  value: _vm.categoria,
                                  callback: function ($$v) {
                                    _vm.categoria = $$v
                                  },
                                  expression: "categoria",
                                },
                              },
                              [
                                _c(VTabsSlider, {
                                  attrs: { color: "secondary" },
                                }),
                                _vm._l(_vm.categorias, function (c) {
                                  return _c(
                                    VTab,
                                    {
                                      key: c.id,
                                      staticClass: "mt-3",
                                      attrs: { href: "#" + c.id },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text--darken-2",
                                        },
                                        [_vm._v(_vm._s(c.descricao))]
                                      ),
                                      _c(
                                        VBadge,
                                        {
                                          attrs: {
                                            color:
                                              c.id === _vm.categoria
                                                ? "secondary"
                                                : "grey",
                                            content: _vm.getTotalComportamentos(
                                              c.id
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                color:
                                                  c.id === _vm.categoria
                                                    ? "secondary"
                                                    : "grey",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(c.icone) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                            _c(
                              VTabsItems,
                              {
                                model: {
                                  value: _vm.categoria,
                                  callback: function ($$v) {
                                    _vm.categoria = $$v
                                  },
                                  expression: "categoria",
                                },
                              },
                              _vm._l(_vm.categorias, function (c) {
                                return _c(
                                  VTabItem,
                                  {
                                    key: c.id,
                                    staticClass: "mt-6",
                                    attrs: { value: c.id },
                                  },
                                  [
                                    _vm.prazoAtual
                                      ? _c(
                                          VRow,
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              VCol,
                                              [
                                                _c(VTextField, {
                                                  ref: c.id,
                                                  refInFor: true,
                                                  attrs: {
                                                    label: _vm.isEditando
                                                      ? "Edite sua resposta"
                                                      : _vm.frase,
                                                  },
                                                  on: {
                                                    keyup: function ($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      )
                                                        return null
                                                      return _vm.salvar.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.comportamento
                                                        .descricao,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.comportamento,
                                                        "descricao",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "comportamento.descricao",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.prazoAtual
                                      ? _c(
                                          VRow,
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(VSpacer),
                                            _c(
                                              VTooltip,
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "right mr-2",
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                VBtn,
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm
                                                                        .comportamento
                                                                        .descricao ===
                                                                      "",
                                                                    color:
                                                                      "primary",
                                                                    depressed:
                                                                      "",
                                                                    medium: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.salvar,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.isEditando
                                                                          ? "Editar"
                                                                          : "Adicionar"
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isEditando
                                                        ? "Clique no botão para editar o comportamento"
                                                        : "Clique no botão para adicionar um comportamento"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              VTooltip,
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g({}, on),
                                                            [
                                                              _c(
                                                                VBtn,
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm
                                                                        .comportamento
                                                                        .descricao ===
                                                                      "",
                                                                    color:
                                                                      "primary",
                                                                    outlined:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.clearFields()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Cancelar "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Clique no botão para cancelar a operação"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      VRow,
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          VCol,
                                          [
                                            _c(VDataTable, {
                                              staticClass: "elevation-0 mt-4",
                                              attrs: {
                                                headers: _vm.headers,
                                                items: _vm.comportamentos,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: `item.acoes`,
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              bottom: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VSpacer
                                                                      ),
                                                                      _vm.prazoAtual
                                                                        ? _c(
                                                                            VBtn,
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "mr-2",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "secondary",
                                                                                    icon: "",
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.prepararEdicao(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                VIcon,
                                                                                [
                                                                                  _vm._v(
                                                                                    "edit"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para editar o comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              bottom: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _vm.prazoAtual
                                                                        ? _c(
                                                                            VBtn,
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "error",
                                                                                    icon: "",
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.confirmDeleteItem(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                VIcon,
                                                                                [
                                                                                  _vm._v(
                                                                                    "delete"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para excluir o comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(VRow, { attrs: { "no-gutters": "" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.prazoAtual &&
                            _vm.usuarioMapeamento.tipo == "REGULAR",
                          expression:
                            "prazoAtual && usuarioMapeamento.tipo == 'REGULAR'",
                        },
                      ],
                      staticClass: "text-lg-right mt-3 mb-3",
                    },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: {
                            disabled: !_vm.isCadastroFinalizado,
                            top: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          disabled: !_vm.isCadastroFinalizado,
                                          color: "secondary",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toogleDialogAgradecimento()
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(" Finalizar "),
                                      _c(VIcon, { staticClass: "ml-2" }, [
                                        _vm._v(" check "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Clique no botão para finalizar o cadastro dos comportamentos"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.dialogs.remove
        ? _c("dialog-remove", {
            attrs: {
              "confirm-action": _vm.excluir,
              "dialog-visible": _vm.dialogs.remove,
              "toogle-visible": _vm.toogleDialogRemove,
              descricao: "Você realmente deseja excluir esse comportamento?",
            },
          })
        : _vm._e(),
      _c("dialog-agradecimento", {
        attrs: {
          "dialog-visible": _vm.dialogs.agradecimento,
          "toogle-visible": _vm.toogleDialogAgradecimento,
          descricao: _vm.mensagemAgradecimento,
          "url-redirecionamento": "/mapeamento",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }